import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import config from '../../../../frontend_config.json';
import {LanguageService} from '../../language/language.service';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['../pages.scss','./contact.component.scss']
})
export class ContactComponent implements OnInit {
  config = config;

  constructor(private meta: Meta, private titleService: Title, public languageService: LanguageService) { }

  ngOnInit(): void {
    // 1. Pobieramy przetłumaczone wartości z sekcji "seo" w Twoich JSONach
    const seoTitle = this.languageService.getLang('contact title', 'seo');
    const seoDesc = this.languageService.getLang('contact desc', 'seo');

    // 2. Ustawiamy tytuł karty w przeglądarce
    this.titleService.setTitle(seoTitle);

    // 3. Aktualizujemy meta description dla Google
    this.meta.updateTag({ name: 'description', content: seoDesc });

    // 4. Opcjonalnie: stałe tagi, które się nie zmieniają
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
  }

}
